/*@jsxRuntime classic @jsx React.createElement @jsxFrag React.Fragment*/
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import React from "react";
function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p",
    a: "a",
    strong: "strong",
    blockquote: "blockquote",
    span: "span",
    h2: "h2",
    ul: "ul",
    li: "li"
  }, _provideComponents(), props.components);
  return React.createElement(React.Fragment, null, React.createElement(_components.p, null, "I am an early adopter of ", React.createElement(_components.a, {
    href: "https://aspnetboilerplate.com/",
    target: "_blank",
    rel: "nofollow noopener"
  }, "aspnetboilerplate"), ". I learned ", React.createElement(_components.strong, null, "AngularJS"), " as part of developing ", React.createElement(_components.a, {
    href: "https://aspnetboilerplate.com/",
    target: "_blank",
    rel: "nofollow noopener"
  }, "aspnetboilerplate"), " project and it all started by reading an awesome blog post ", React.createElement(_components.a, {
    href: "https://www.codeproject.com/Articles/768664/Introduction-to-ASP-NET-Boilerplate",
    target: "_blank",
    rel: "nofollow noopener"
  }, "Introduction to ASP.NET Boilerplate"), " by ", React.createElement(_components.strong, null, "Halil ibrahim Kalkan"), ". Since then I always recommended using the paid ", React.createElement(_components.a, {
    href: "https://aspnetzero.com/",
    target: "_blank",
    rel: "nofollow noopener"
  }, "aspnetzero"), " template for all the major projects in my workplace. And I used the free ", React.createElement(_components.a, {
    href: "https://aspnetboilerplate.com/",
    target: "_blank",
    rel: "nofollow noopener"
  }, "aspnetboilerplate"), " template for some of the projects including my side project, ", React.createElement(_components.a, {
    href: "https://github.com/piggyvault/piggyvault",
    target: "_blank",
    rel: "nofollow noopener"
  }, "piggyvault"), ", a family finance management app, and its APIs is built on ", React.createElement(_components.a, {
    href: "https://github.com/aspnetboilerplate/aspnetboilerplate",
    target: "_blank",
    rel: "nofollow noopener"
  }, "aspnetboilerplate"), "."), "\n", React.createElement(_components.p, null, "Similarly, I use ", React.createElement(_components.a, {
    href: "https://www.cloudflare.com/",
    target: "_blank",
    rel: "nofollow noopener"
  }, "Cloudflare"), " for most of the hosted websites as a firewall-cum-CDN. Recently after hosting the ", React.createElement(_components.a, {
    href: "https://aspnetboilerplate.com/",
    target: "_blank",
    rel: "nofollow noopener"
  }, "aspnetboilerplate"), " project on ", React.createElement(_components.a, {
    href: "https://www.SmarterASP.NET/index?r=100571651",
    target: "_blank",
    rel: "nofollow noopener"
  }, "SmarterASP.net"), ", I started to face a login issue where it was working fine on local (as always 😆). The traffic to the PROD app was routed via ", React.createElement(_components.a, {
    href: "https://www.cloudflare.com/",
    target: "_blank",
    rel: "nofollow noopener"
  }, "Cloudflare"), "."), "\n", React.createElement(_components.p, null, "Later the troubleshooting journey ended up ", React.createElement(_components.a, {
    href: "https://support.cloudflare.com/hc/en-us/articles/200170986-How-does-Cloudflare-handle-HTTP-Request-headers-",
    target: "_blank",
    rel: "nofollow noopener"
  }, "here"), "."), "\n", React.createElement(_components.blockquote, null, "\n", React.createElement(_components.p, null, "Cloudflare strips any header that contains dots (.) from origin web server responses. For example, the origin web server header test.header:data is removed by Cloudflare’s proxy."), "\n"), "\n", React.createElement(_components.p, null, "By default, ABP uses ", React.createElement(_components.span, {
    dangerouslySetInnerHTML: {
      __html: "<code class=\"language-text\">Abp.TenantId</code>"
    }
  }), " header as the ", React.createElement(_components.span, {
    dangerouslySetInnerHTML: {
      __html: "<code class=\"language-text\">TenantIdResolveKey</code>"
    }
  }), ", and ", React.createElement(_components.strong, null, "Cloudflare"), " strips it resulting in null value always. Thankfully, ", React.createElement(_components.a, {
    href: "https://aspnetboilerplate.com/",
    target: "_blank",
    rel: "nofollow noopener"
  }, "aspnetboilerplate"), " provides an option to change the ", React.createElement(_components.span, {
    dangerouslySetInnerHTML: {
      __html: "<code class=\"language-text\">TenantIdResolveKey</code>"
    }
  }), ". To change,"), "\n", React.createElement(_components.p, null, "In the ", React.createElement(_components.span, {
    dangerouslySetInnerHTML: {
      __html: "<code class=\"language-text\">CoreModule</code>"
    }
  }), ","), "\n", React.createElement(_components.span, {
    dangerouslySetInnerHTML: {
      __html: "<div class=\"gatsby-highlight\" data-language=\"cs\"><pre class=\"language-cs\"><code class=\"language-cs\"><span class=\"token comment\">// Enable this line to create a multi-tenant application.</span>\nConfiguration<span class=\"token punctuation\">.</span>MultiTenancy<span class=\"token punctuation\">.</span>IsEnabled <span class=\"token operator\">=</span> PiggyvaultConsts<span class=\"token punctuation\">.</span>MultiTenancyEnabled<span class=\"token punctuation\">;</span>\nConfiguration<span class=\"token punctuation\">.</span>MultiTenancy<span class=\"token punctuation\">.</span>TenantIdResolveKey <span class=\"token operator\">=</span> <span class=\"token string\">\"Piggy-TenantId\"</span><span class=\"token punctuation\">;</span> <span class=\"token comment\">// your key without \".\"</span></code></pre></div>"
    }
  }), "\n", React.createElement(_components.p, null, "It resolved the login issue."), "\n", React.createElement(_components.h2, {
    id: "additional-resources",
    style: {
      position: "relative"
    }
  }, React.createElement(_components.a, {
    href: "#additional-resources",
    "aria-label": "additional resources permalink",
    className: "anchor before"
  }, React.createElement(_components.span, {
    dangerouslySetInnerHTML: {
      __html: "<svg aria-hidden=\"true\" focusable=\"false\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg>"
    }
  })), "Additional Resources"), "\n", React.createElement(_components.ul, null, "\n", React.createElement(_components.li, null, React.createElement(_components.a, {
    href: "https://github.com/aspnetboilerplate/aspnetboilerplate/issues/3275",
    target: "_blank",
    rel: "nofollow noopener"
  }, "Can not get header with name “Abp.TenantId” but “AbpTenantId” on server(windwos / linux).")), "\n", React.createElement(_components.li, null, React.createElement(_components.a, {
    href: "https://github.com/aspnetboilerplate/aspnetboilerplate/pull/4349",
    target: "_blank",
    rel: "nofollow noopener"
  }, "Allow to configure TenantIdResolveKey")), "\n"));
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? React.createElement(MDXLayout, props, React.createElement(_createMdxContent, props)) : _createMdxContent(props);
}
export default MDXContent;
